import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, "Edit Persons Related to Case", -1)
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-6 text-sm font-normal text-gray-900" }
const _hoisted_5 = { class: "text-sm font-normal text-gray-900" }
const _hoisted_6 = { class: "text-sm font-normal text-gray-900" }
const _hoisted_7 = { class: "text-sm font-normal text-gray-900" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "text-sm font-normal text-gray-900" }
const _hoisted_12 = { class: "text-sm font-normal text-gray-900" }
const _hoisted_13 = { class: "flex justify-center p-6 space-x-2" }
const _hoisted_14 = { class: "flex justify-end col-span-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Add New", -1)
const _hoisted_16 = {
  key: 1,
  class: "col-span-12"
}

import PageLoader from "@/components/loaders/PageLoader.vue"
import IntakeLayout from '../../Component/IntakeLayout.vue';
import ViewButton from "@/components/buttons/ViewButton.vue";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import DataTable from "@/components/partials/DataTable.vue";
import EditPage from './EditPage.vue';
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";


import { ref, onMounted,computed } from 'vue';
import { PlusIcon } from "@heroicons/vue/24/solid";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { useRouter, useRoute } from "vue-router";
import PersonRelatedToCaseService from '@/classes/Cases/IntakeForms/PersonRelatedToCaseService';
import { OptionInterface } from '@/interfaces/OptionInterface';
import { BirthdayClassification } from "@/views/enums/BirthdayClassification";
import { errorResponse } from "@/helpers/errorMessage";
import DateFormatter from "@/helpers/DateFormatter";
import { onIonViewWillEnter } from "@ionic/vue";

 
 /******************************* For Offline Imports************************************ */
 import { useNetworkStore } from "@/store/network";
 import Rules from "@/classes/Cases/Intake/RelatedToCase/Validation/Rules";
 import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
 import useVuelidate from "@vuelidate/core";
 import Relationships from "@/classes/Forms/Relationships";
 import RelatedToCaseService from "@/classes/Cases/Intake/RelatedToCase/RelatedToCaseService";
 import RelatedToCaseForm from "@/classes/Cases/Intake/RelatedToCase/Formatters/RelatedToCaseForm";
 import PersonRelatedOfflineProcessor from "@/classes/Cases/Intake/RelatedToCase/Processor/OfflineProcessor";
 import OnlineSynching from "@/classes/Synching/OnlineSynching";
 import CaseGuardianOfflineProcessor from "@/classes/Cases/CaseGuardian/Offline/Processor/OfflineProcessor";

 
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const { createRules } = Rules;
 const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
 const relationship = new Relationships()
 /*************************************************************************************** */
 
const route = useRoute();
const form = ref({})
const errors = ref<any>();

const isShowNav = ref<boolean>(true);
const showSuccess = ref<boolean>(false);
const loading = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const editForm = ref<any>({});

const selectedItem = ref<number>(0);
const route_params = route.params;
const onlineSync = new OnlineSynching();

const headers = [
    { text: 'Full Name' },
    { text: 'Gender' },
    { text: 'Relationship' },
    { text: 'Birthdate' },
    { text: 'Age' },
    { text: 'Contact Number' }
]
const birthdayClassification = ref<OptionInterface[]>([]);
const personRelatedType = ref<OptionInterface[]>([]);
const companionRelationship = ref<OptionInterface[]>([]);
const civilStatus = ref<OptionInterface[]>([]);
const educationalAttainment = ref<OptionInterface[]>([]);
const housingClassification = ref<OptionInterface[]>([]);
const genders = ref<OptionInterface[]>([]);
const patient = ref<string>('');
const isIonWillEnter = ref<boolean>(false);
const patientCase = ref(route_params?.case);
const optionYerOrNo = [
    { id: 0, value: 0, label: 'No' },
    { id: 1, value: 1, label: 'Yes' },
]

const data = {
    id:  0,
    name: '-',
    gender_formatted: '-',
    companion_relationship: '-',
    birthdate: null,
    computed_age: '-',
    contacts: '-'
}


const items = ref({
    data: [ data ]
})

const addNew = () => {
    isShowNav.value = false;
    errors.value = null;
    Object.assign(form.value, RelatedToCaseForm.createForm(patientCase)); 
}

const save = async () => {
    loading.value = true;
    form.value = editForm.value.formData;
     
    if(form.value.id){
        await RelatedToCaseService.update(form.value.id, route_params?.patient, route_params?.case, isNetworkAvailable.value, form.value)
        .then(async({data}) => {
            loading.value = false; 
            items.value = data.items;
            showSuccess.value = true;
            isShowNav.value = true;
            await fetch();
            if(isNetworkAvailable.value){
                await PersonRelatedOfflineProcessor.syncToOffline(route_params?.case, form.value);
                setTimeout(() => {
                    location.reload()
                }, 1000);
                // clearForm()
            }
        })
        .catch(error => {
            loading.value = false;
            errors.value = errorResponse(error.response?.data?.errors)
        })
    } else {
        await RelatedToCaseService.store(form.value.id, route_params?.patient, route_params?.case,isNetworkAvailable.value, form.value)
        .then(async({data}) => {
            loading.value = false; 
            items.value = data.items;
            showSuccess.value = true;
            isShowNav.value = true;
            await fetch();
            if(isNetworkAvailable.value){
                await PersonRelatedOfflineProcessor.syncToOffline(route_params?.case, form.value);
                setTimeout(() => {
                    location.reload()
                }, 1000);
                // clearForm()
            }
        })
        .catch(error => {
            loading.value = false;
            errors.value = errorResponse(error.response?.data?.errors)
        })
    }  
}


const fetch = async ():void => {
    loading.value = true;
    // PersonRelatedToCaseService
    await RelatedToCaseService
        .index(route_params?.patient, route_params?.case, isNetworkAvailable.value)
        .then(async ({data}) => {
            console.log(data.items);
            items.value = data.items;
            console.log(items.value.data);
            if (isNetworkAvailable.value) {
                await syncToOffline();
            }
            birthdayClassification.value = data.birthdayClassification
            personRelatedType.value = data.personRelatedType
            companionRelationship.value = data.companionRelationship
            civilStatus.value = data.civilStatus
            educationalAttainment.value = data.educationalAttainment
            housingClassification.value = data.housingClassification
            patient.value = data.patient
            genders.value = data.genders
            loading.value = false;
        })
        .catch(errors => {
            console.log(errors)
        })
}

const syncToOffline = async () => {
    for (const index in items.value.data) {
        const item = items.value.data[index];
        await PersonRelatedOfflineProcessor.syncToOffline(route_params?.case, item);
    }
}
 
 /**
 * Validate the form using Vuelidator
 */
 const validateForm = () =>{
    form.value = editForm.value.formData;
	const vuelidate = useVuelidate(createRules({...form.value}), form.value)
	const result = vuelidate.value.$validate();

	result
		.then((res) => {
			if(res) {
				save()
			} else {
				errors.value = ErrorValidation.getErrors(vuelidate.value)
                errorResponse(errors.value);
			}
		}) 
 }
 
const showConfirmationModal = (item:number):void => {
    showConfirmation.value = true;
    selectedItem.value = item
}


const archive = async ():void => {
    loading.value = true;
    showConfirmation.value = false;

    await RelatedToCaseService
    .archive(route_params?.patient, route_params?.case, selectedItem.value, isNetworkAvailable.value)
    .then(async ({data}) => {
        if (isNetworkAvailable.value) {
            await CaseGuardianOfflineProcessor.delete(selectedItem.value, route_params?.case, true);
        }
        await fetch()
        loading.value = false;
    })
    .catch(errors => {
        console.log(errors)
        loading.value = false;
    })
}

const showForm = (item:any) => { 
    errors.value = null;
    Object.assign(form.value, RelatedToCaseForm.updateForm(item));
    form.value.cases_id = route_params?.case;
    isShowNav.value = false;
} 

 
onIonViewWillEnter(async () => {
    if (isIonWillEnter.value) {
        await fetch(); 
        await onlineSync.checkDrafts();
    }
});

onMounted(async () => {
    await fetch();
    await onlineSync.checkDrafts();
    isIonWillEnter.value = true;
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IntakeLayout, {
    isShowNav: isShowNav.value,
    patient: patient.value
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    actionButtons: _withCtx(() => [
      (!isShowNav.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(ButtonComponent, {
              btnWidth: "quinary",
              fill: "outline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowNav.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            }),
            _createVNode(ButtonComponent, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (validateForm()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Save Changes ")
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (isShowNav.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(DataTable, {
                headers: headers,
                "no-action": false,
                count: items.value?.data?.length,
                dataTableClass: "border-t-0 border-x-0 "
              }, {
                body: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item?.id
                    }, [
                      (item?.id > 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                            _createElementVNode("td", _hoisted_4, _toDisplayString(item?.name), 1),
                            _createElementVNode("td", _hoisted_5, _toDisplayString(item?.gender_formatted), 1),
                            _createElementVNode("td", _hoisted_6, _toDisplayString(item?.companion_relationship ?? ""), 1),
                            _createElementVNode("td", _hoisted_7, [
                              (_unref(BirthdayClassification).BIRTHDATE == item?.birthday_classification)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(DateFormatter).customDateFormat(item?.birthdate, 'MM/dd/yyy')), 1))
                                : (_unref(BirthdayClassification).APPROXIMATE_AGE == item?.birthday_classification)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Approximate age "))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_10, " Unknown "))
                            ]),
                            _createElementVNode("td", _hoisted_11, _toDisplayString(item?.computed_age), 1),
                            _createElementVNode("td", _hoisted_12, _toDisplayString(item?.contacts ? "+63"+item?.contacts : '-'), 1),
                            _createElementVNode("td", _hoisted_13, [
                              _createVNode(ViewButton, {
                                isEyeIcon: false,
                                onClick: ($event: any) => (showForm(item)),
                                class: "shrink-0"
                              }, null, 8, ["onClick"]),
                              _createVNode(DeleteButton, {
                                class: "shrink-0",
                                onClick: ($event: any) => (showConfirmationModal(item?.id))
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["count"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(ButtonComponent, {
                customClass: "primary sm:w-auto w-full",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addNew()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PlusIcon), { class: "w-3.5 h-3.5" }),
                  _hoisted_15
                ]),
                _: 1
              })
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(EditPage, {
              ref_key: "editForm",
              ref: editForm,
              form: form.value,
              errors: errors.value,
              optionRelationChild: companionRelationship.value,
              optionBirthday: birthdayClassification.value,
              optionSelected: personRelatedType.value,
              optionCivilStatus: civilStatus.value,
              optionYerOrNo: optionYerOrNo,
              optionEducationAttain: educationalAttainment.value,
              optionHousingClass: housingClassification.value,
              optionGenders: genders.value
            }, null, 8, ["form", "errors", "optionRelationChild", "optionBirthday", "optionSelected", "optionCivilStatus", "optionEducationAttain", "optionHousingClass", "optionGenders"])
          ])),
      _createVNode(SuccessModal, {
        noBtn: "",
        show: showSuccess.value,
        "action-text": "Close",
        title: "Record Save",
        content: "Intake has been updated",
        onClose: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false))
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (archive())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Delete Record",
        content: "Are you sure you wish to delete this Person?"
      }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["isShowNav", "patient"]))
}
}

})